module.exports = __webpack_public_path__ + "img/bb_g3_t_eyes-02.67b97a7c.svg";